import { jsxs as K, jsx as r } from "react/jsx-runtime";
import { CloseIcon as N, ReloadIcon as D } from "../../icons/index.es.js";
import { FormikContext as rr, Field as or } from "formik";
import { forwardRef as er, useState as tr, useContext as ir, useMemo as O } from "react";
import { getChakraProps as nr } from "../../utils/props.es.js";
import { FormLabel as ar } from "../Form/FormLabel.es.js";
import { chakra as x, FormControl as lr } from "@chakra-ui/react";
import { FormHelperText as cr } from "../Form/FormHelperText.es.js";
import { FormErrorMessage as sr } from "../Form/FormError.es.js";
import { IconButton as M } from "../Button/Button.es.js";
import { MagicAniamtedFilledIcon as mr } from "../MagicAniamtedFilledIcon/MagicAniamtedFilledIcon.es.js";
import { SmartAnimation as pr } from "../SmartAnimation/SmartAnimation.es.js";
import { Tooltip as dr } from "../Tooltip/Tooltip.es.js";
import { useInputStyle as fr } from "./Input.context.es.js";
import { validateField as ur } from "./Input.validation.es.js";
import { InputGroup as hr } from "./components/InputGroup.es.js";
import { InputLeftAddon as vr } from "./components/InputLeftAddon.es.js";
import { InputRightAddon as f } from "./components/InputRightAddon.es.js";
const Vr = er(
  ({
    clearButtonProps: u,
    disableFormik: h = !1,
    error: Q,
    info: b,
    inputGroupProps: U,
    isDisabled: v,
    isFullWidth: X,
    isInvalid: _,
    isLoading: n,
    isReadOnly: k,
    isRequired: E,
    isSmartData: t = !1,
    label: z,
    leftAddon: s,
    leftAddonProps: Y,
    onChange: Z,
    onClear: m,
    onRetry: S,
    rightAddon: a,
    rightAddonProps: p,
    sx: R,
    testId: T,
    trackId: $,
    value: y,
    withClearButton: I = !0,
    name: e,
    placeholder: W,
    ...j
  }, w) => {
    const [G, C] = tr(!1), V = t, o = h ? void 0 : ir(rr), F = j.variant === "error", l = fr(), g = t && n, H = O(() => t && n && !W ? "Gathering data..." : W, [t, n]), q = o && !h && e, L = O(() => {
      let c = l.field;
      return s && (c = { ...c, ...l.fieldWithLeftAddon }), (a || I) && (c = { ...c, ...l.fieldWithRightAddon }), c;
    }, [l.field, s, a, I]);
    !h && o && !e && console.warn("Input component is used inside Formik context without a name prop");
    const i = Q ?? (o == null ? void 0 : o.errors[e]), d = o ? o.touched[e] : !!i, B = e ? o == null ? void 0 : o.values[e] : void 0, { space: P, flex: A, ...J } = nr(j);
    return /* @__PURE__ */ K(
      x.div,
      {
        pointerEvents: g ? "none" : "auto",
        as: lr,
        __css: l.control,
        isInvalid: _ ?? !!(i && d),
        isRequired: E,
        minWidth: X ? "full" : "min-content",
        ...P,
        ...A,
        children: [
          z && /* @__PURE__ */ r(ar, { children: z + " " }),
          /* @__PURE__ */ r(pr, { isLoading: n, size: "fullwidth", children: /* @__PURE__ */ K(
            hr,
            {
              "data-group": "",
              "track-id": $,
              "data-invalid": _ ?? !!(i && d) ? "" : void 0,
              ...U,
              children: [
                s && /* @__PURE__ */ r(vr, { ...Y, children: s }),
                q ? /* @__PURE__ */ r(
                  x.input,
                  {
                    __css: L,
                    as: or,
                    "data-disabled": v,
                    "data-testid": T,
                    name: e,
                    placeholder: H,
                    innerRef: w,
                    sx: R,
                    validate: E ? ur : void 0,
                    ...J
                  }
                ) : /* @__PURE__ */ r(
                  x.input,
                  {
                    __css: L,
                    "data-disabled": v,
                    "data-testid": T,
                    name: e,
                    onChange: Z,
                    placeholder: H,
                    readOnly: k,
                    ref: w,
                    sx: R,
                    value: y,
                    ...J
                  }
                ),
                V && !F && !G && /* @__PURE__ */ r(
                  f,
                  {
                    ...p,
                    onMouseEnter: () => {
                      (y || B) && C(!0);
                    },
                    children: /* @__PURE__ */ r(mr, { animated: n })
                  }
                ),
                (y || B) && G && t && !F && /* @__PURE__ */ r(
                  f,
                  {
                    ...p,
                    onMouseLeave: () => C(!1),
                    children: /* @__PURE__ */ r(
                      dr,
                      {
                        label: "Clear info added by Smart Profiles",
                        "aria-label": "Clear info added by Smart Profiles",
                        placement: "top-end",
                        children: /* @__PURE__ */ r(
                          M,
                          {
                            "aria-label": "Clear",
                            icon: /* @__PURE__ */ r(N, { color: "primary.300" }),
                            onClick: () => {
                              m == null || m(), C(!1);
                            },
                            size: "sm",
                            variant: "transparent",
                            ...u
                          }
                        )
                      }
                    )
                  }
                ),
                F && t && S && /* @__PURE__ */ r(f, { ...p, children: /* @__PURE__ */ r(
                  M,
                  {
                    "aria-label": "Retry",
                    icon: /* @__PURE__ */ r(D, { color: "primary.300" }),
                    onClick: S,
                    size: "sm",
                    variant: "transparent",
                    ...u
                  }
                ) }),
                (I || a) && !v && !k && !V && /* @__PURE__ */ r(f, { ...p, children: a || /* @__PURE__ */ r(
                  M,
                  {
                    "aria-label": "Clear",
                    icon: /* @__PURE__ */ r(N, { color: "primary.300" }),
                    onClick: m,
                    size: "sm",
                    variant: "transparent",
                    ...u
                  }
                ) })
              ]
            }
          ) }),
          !!i && d && /* @__PURE__ */ r(sr, { children: i }),
          !!b && !(i && d) && /* @__PURE__ */ r(cr, { children: b })
        ]
      }
    );
  }
);
export {
  Vr as InputComponent
};
//# sourceMappingURL=Input.component.es.js.map
